/**
 * Id корня дерева меню
 */
export const ROOT_PARENT_ID = 1;

/**
 * Задержка перед началом перетаскивания, мс
 */
export const WAIT_TIME_MS = 1000;
